export default "__VITE_ASSET__Dvs42AYM__"